import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import {
    Button,
    Box,
    InputAdornment,
    Card,
    CardContent,
    Grid,
    Typography,
    TextField,
    InputLabel,
    MenuItem,
    FormControl,
    Select
} from '@mui/material';
import { useDeadline } from "../../../contexts/DeadlineContext";

const PayTabTwo = () => {
    const history = useHistory();
    const eventid = localStorage.getItem('eventid');
    const { abstractHomeSetup } = useDeadline();

    const [settings, setPyamentSettings] = useState({
        PAYTAB_COUNTRY_TWO: '',
        PAYTAB_MERCHANT_EMAIL_TWO: '',
        PAYTAB_SECRET_KEY_TWO: '',
        PAYTAB_MERCHANT_ID_TWO: '',
        PAYTAB_STATUS_TWO: '',
        PAYTAB_MODE_TWO: '',
        PAYTAB_CURRENCY_TWO: "",
        PAYTAB_TAX_TWO: "",
        BANK_STATUS_TWO: "",
        CASH_STATUS_TWO: "",
        FREE_STATUS_TWO: "",
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        axios.get(`/api/get-setting/${eventid}`)
            .then(response => {
                setPyamentSettings(response.data.settings || {});
            })
            .catch(error => {
                console.error('Error fetching email settings:', error);
            });
    }, [eventid]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setErrors(prev => ({ ...prev, [name]: '' }));

        if (name === "PAYTAB_COUNTRY_TWO") {
            let currency = "";
            switch (value) {
                case "SAU": currency = "SAR"; break;
                case "ARE": currency = "AED"; break;
                case "USA": currency = "USD"; break;
                default: currency = "";
            }

            setPyamentSettings(prev => ({
                ...prev,
                PAYTAB_COUNTRY_TWO: value,
                PAYTAB_CURRENCY_TWO: currency
            }));
        } else {
            setPyamentSettings(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            'PAYTAB_COUNTRY_TWO',
            'PAYTAB_MERCHANT_EMAIL_TWO',
            'PAYTAB_SECRET_KEY_TWO',
            'PAYTAB_MERCHANT_ID_TWO',
            'PAYTAB_CURRENCY_TWO',
            'PAYTAB_TAX_TWO'
        ];

        requiredFields.forEach(field => {
            if (!settings[field]) {
                newErrors[field] = 'This field is required';
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const StorePyamentSetting = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            swal('Error', 'Please fill all required fields', 'error');
            return;
        }

        setIsSubmitting(true);
        
        try {
            await axios.get('/sanctum/csrf-cookie');
            const response = await axios.post('/api/configuration-setting', {
                eventid,
                settings
            });

            if (response.data.status === 200) {
                await swal({
                    title: 'Success',
                    text: response.data.message,
                    icon: 'success',
                    buttons: {
                        confirm: {
                            text: 'OK',
                            className: 'swal-confirm-button',
                        }
                    }
                });
                history.push('/admin/payment/paytab');
            } else {
                throw new Error(response.data.message || 'Failed to save settings');
            }
        } catch (error) {
            console.error('Error:', error);
            swal('Error', error.message || 'Failed to save settings', 'error');
        } finally {
            setIsSubmitting(false);
        }
    };

    const backGroundButtonByEvent = abstractHomeSetup?.color_code_two || '#145348';

    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000', marginTop: '5%' }}>
                <h4 style={{ display: 'flex', justifyContent: 'flex-end', gap: '1%' }}>
                    <Button
                        sx={{
                            backgroundColor: backGroundButtonByEvent,
                            "&:hover": { backgroundColor: backGroundButtonByEvent, opacity: 0.9 }
                        }}
                        variant='contained'
                        onClick={() => history.push('/admin/payment/setting')}
                    >
                        Payment Settings
                    </Button>
                    <Button sx={{
                            backgroundColor: backGroundButtonByEvent,
                            "&:hover": { backgroundColor: backGroundButtonByEvent, opacity: 0.9 }
                        }}
                        variant='contained'
                        onClick={() => history.push('/admin/payment/paytab')}>
                        Purplecube AED Payment Settings
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: backGroundButtonByEvent,
                            "&:hover": { backgroundColor: backGroundButtonByEvent, opacity: 0.9 }
                        }}
                        variant='contained'
                        onClick={() => history.goBack()}
                    >
                        Back
                    </Button>
                </h4>

                <Card sx={{ width: '60vw' }}>
                    <CardContent>
                        <Typography component="h1" variant="h5">
                            Purplecube USD PayTab Payment settings
                        </Typography>
                        <Box component="form" onSubmit={StorePyamentSetting} noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={4}>
                                <Grid item xs={6}>
                                    <FormControl fullWidth error={!!errors.PAYTAB_COUNTRY_TWO}>
                                        <InputLabel>Country</InputLabel>
                                        <Select
                                            name="PAYTAB_COUNTRY_TWO"
                                            value={settings.PAYTAB_COUNTRY_TWO}
                                            label="Country"
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="SAU">Saudi Arabia</MenuItem>
                                            <MenuItem value="ARE">United Arab Emirates</MenuItem>
                                            <MenuItem value="USA">United States</MenuItem>
                                        </Select>
                                        {errors.PAYTAB_COUNTRY_TWO && (
                                            <Typography variant="caption" color="error">
                                                {errors.PAYTAB_COUNTRY_TWO}
                                            </Typography>
                                        )}
                                    </FormControl>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        required
                                        label="Merchant Email"
                                        name="PAYTAB_MERCHANT_EMAIL_TWO"
                                        value={settings.PAYTAB_MERCHANT_EMAIL_TWO}
                                        onChange={handleChange}
                                        error={!!errors.PAYTAB_MERCHANT_EMAIL_TWO}
                                        helperText={errors.PAYTAB_MERCHANT_EMAIL_TWO}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        required
                                        label="Secret Key"
                                        name="PAYTAB_SECRET_KEY_TWO"
                                        value={settings.PAYTAB_SECRET_KEY_TWO}
                                        onChange={handleChange}
                                        error={!!errors.PAYTAB_SECRET_KEY_TWO}
                                        helperText={errors.PAYTAB_SECRET_KEY_TWO}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        required
                                        label="Merchant ID"
                                        name="PAYTAB_MERCHANT_ID_TWO"
                                        value={settings.PAYTAB_MERCHANT_ID_TWO}
                                        onChange={handleChange}
                                        error={!!errors.PAYTAB_MERCHANT_ID_TWO}
                                        helperText={errors.PAYTAB_MERCHANT_ID_TWO}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <FormControl fullWidth error={!!errors.PAYTAB_CURRENCY_TWO}>
                                        <InputLabel>Currency</InputLabel>
                                        <Select
                                            name="PAYTAB_CURRENCY_TWO"
                                            value={settings.PAYTAB_CURRENCY_TWO}
                                            label="Currency"
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="SAR">Saudi Riyal (SAR)</MenuItem>
                                            <MenuItem value="AED">UAE Dirham (AED)</MenuItem>
                                            <MenuItem value="USD">US Dollar (USD)</MenuItem>
                                        </Select>
                                        <Typography variant="caption" color="textSecondary">
                                            Automatically set based on country selection
                                        </Typography>
                                        {errors.PAYTAB_CURRENCY_TWO && (
                                            <Typography variant="caption" color="error">
                                                {errors.PAYTAB_CURRENCY_TWO}
                                            </Typography>
                                        )}
                                    </FormControl>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        required
                                        label="Tax Rate"
                                        name="PAYTAB_TAX_TWO"
                                        value={settings.PAYTAB_TAX_TWO}
                                        onChange={handleChange}
                                        error={!!errors.PAYTAB_TAX_TWO}
                                        helperText={errors.PAYTAB_TAX_TWO}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <InputLabel>Mode</InputLabel>
                                        <Select
                                            name="PAYTAB_MODE_TWO"
                                            value={settings.PAYTAB_MODE_TWO}
                                            label="Mode"
                                            onChange={handleChange}
                                        >
                                            <MenuItem value={1}>Online</MenuItem>
                                            <MenuItem value={0}>Offline</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Box sx={{ mt: 5, display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{ backgroundColor: backGroundButtonByEvent }}
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? 'Submitting...' : 'Submit'}
                                </Button>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
};

export default PayTabTwo;